import { LoaderSpinnerComponent } from '@aston/foundation/components';
import { ActivatedRoute, Router } from '@angular/router';
import { UnsubscriberClass } from '@aston/foundation';
import { Component, OnInit, inject } from '@angular/core';
import { delay, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { SubsidiariesStoreSelectors } from '../../../root-store/subsidiaries-store';
import { PostLoginRouteService } from '../../../shared-module/services';
import * as RoutesDefinitions from '../../../routes-definitions';
import { AuthenticationService } from '../../services';

@Component({
	selector: 'login-callback-page',
	templateUrl: './login-callback-page.component.html',
	imports: [LoaderSpinnerComponent]
})
export class LoginCallbackPageComponent extends UnsubscriberClass implements OnInit {
	private authenticationService = inject(AuthenticationService);
	private postLoginRouteService = inject(PostLoginRouteService);
	private route = inject(ActivatedRoute);
	private router = inject(Router);
	private store = inject(Store);

	subsidiaries$ = this.store.select(SubsidiariesStoreSelectors.selectSubsidiaries);

	ngOnInit() {
		this.route.queryParams.pipe(
			takeUntil(this.destroySubscriptions$)
		).subscribe(_ => {
			this.authenticationService.getIsAuthorized().pipe(delay(0)).subscribe(isAuth => {
				if (!isAuth) {
					this.router.navigate([RoutesDefinitions.getLoginFullPath()]);
				} else if (this.route.snapshot.data.fromSignup) {
					this.router.navigate([RoutesDefinitions.getNewAccountCompanyFullPath()]);
				} else if (!this.postLoginRouteService.hasPostLoginRoute()) {
					this.router.navigate([RoutesDefinitions.getSubsidiariesFullPath()]);
				}
			});
		})
	}
}
